<script setup>
const props = defineProps({
  colorScale: { type: [Object, null], default: null }
})

const scaleOptions = { unit: 'mm/h' }

const palette = computed(() => {
  if (props.colorScale) {
    return props.colorScale.palette.concat([[null, ...props.colorScale.default]])
  }
  return []
})

const getScaleLabel = (index) => {
  if (index === 0) return ''

  const [v] = props.colorScale.palette[index - 1]
  let value = ''

  if (props.colorScale.type === 'linear') {
    const offset = props.colorScale.options.offset ?? 0
    value = offset + props.colorScale.options.step * index
  } else {
    if (scaleOptions?.showFirstLabel === false && index === 0) {
      return ''
    } else {
      value = v
    }
  }
  return scaleOptions?.round ? scaleOptions?.round(value) : value
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const getRGBA = ([v, r, g, b, a]) => {
  return `rgba(${r}, ${g}, ${b}, ${a})`
}
</script>

<template>
  <div
    v-if="colorScale"
    id="scale"
  >
    <div id="scale-block">
      <ul id="scale-bar">
        <li
          v-for="(color, index) in palette"
          :key="index"
          :style="{ backgroundColor: getRGBA(color) }"
          :data-label="getScaleLabel(index)"
        />
      </ul>
      <div
        v-cloak
        v-if="scaleOptions.unit"
        id="scale-unit"
      >
        {{ scaleOptions.unit }}
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
#scale {
  display: flex;
  justify-content: center;
  padding-bottom: 27px;
}

#scale ul {
  display: flex;
  width: 100%;
  height: 18px;
  list-style-type: none;
  padding: 0;
  border: 1px solid #999;
}

#scale li {
  flex: 1;
  position: relative;
}

#scale li:nth-child(2)::after  {
  transform: translateX(-60%);
}

#scale li::after {
  content: attr(data-label);
  position: absolute;
  top: 15px;
  font-size: 12px;
  transform: translateX(-50%);
  color:  #fff;
}

#scale-unit {
  position: absolute;
  left: calc(100% - 30px);
  top: calc(100% + 12px);
  color: #fff;
  font-size: 10px;
}

#scale-block {
  position: relative;
  width: 130px;
  margin-inline: auto;
}
</style>
